export const REQUIRED = 'Required';
export const CORPORATE_LABEL = 'Corporate';
export const COUNTER_PARTY_LABEL = 'Counterparty';
export const USER_LABEL = 'User';
export const APPROVED = 'APPROVED';
export const REJECTED = 'REJECTED';
export const ASSIGNED = 'ASSIGNED';
export const SUBMITTED = 'SUBMITTED';
export const PENDING = 'PENDING'
export const ADD = 'Add';
export const REARRANGE = 'Rearrange';
export const DATA = 'DATA';
export const PREDEFINED = 'PREDEFINED'
export const VIDEO_KYC = 'VIDEO_KYC';
export const COMPLETED = 'COMPLETED';
export const ONHOLD = 'ONHOLD';
export const WITHDRAWN = 'WITHDRAWN';
export const FINANCIAL = 'FINANCIAL';
export const NONFINANCIALDATA = 'NonFinancialData';
export const FINANCIALDATA = 'FinancialData';
export const RECALCULATE = 'Recalculate';
export const SAVE = 'Save';
export const CLOSE = 'Close';
export const REFRESH = 'Refresh';
export const REALLOCATE = 'Reallocate';
export const OVERRIDDING = 'overridding';
export const SYSTEMDEFINED = 'SYSTEMDEFINED';
export const GENERAL = 'GENERAL';
export const DOMESTIC = 'DOMESTIC';
export const INTERNATIONAL = 'INTERNATIONAL';
export const INDIA_COUNTRY_CODE = 'IN';
export const COUNTERPARTY_CLASSIFICATION = 'counterpartyClassification';
export const INDIA_OBJECT = {
    id: 'IN',
    value: 'India'
}
export const EKYC = "EKYC";
export const VKYC = "VKYC";

export const PLATFORM_RUBIX_KYC = "RUBIX_KYC"
export const PLATFORMS = [ {label:"ARMS"}, {label:"EWS"}, {label:PLATFORM_RUBIX_KYC}, {label:"KYC_API"} ];

export const commonJson = {
    "caseId": "",
    "counterpartyId": "",
    "auditors_International": "",
    "solicitors_International": "",
    "name_International": "",
    "former_Name_International": "",
    "trading_Name_International": "",
    "address_International": "",
    "type_of_Company_International": "",
    "year_Established_International": "",
    "company_Status_International": "",
    "registration_Number_International": "",
    "other_Identifiers_International": "",
    "business_Category_International": "",
    "business_Classification_International": "",
    "employee_Size_International": "",
    "comments_International": "",
    "whether_the_country_is_was_under_Lockdown_LD_International": "",
    "period_of_LD_International": "",
    "covid_19_Impact_International": "",
    "measures_taken_by_subject_company_to_mitigate_Risk_arising_from_Covid_19_International": "",
    "name_of_Entity_Enquiry_Details_International": "",
    "address_of_Entity_Enquiry_Details_International": "",
    "country_Enquiry_Details_International": "",
    "enquiry_Reference_Number_Enquiry_Details_International": "",
    "buyer_Code_Enquiry_Details_International": "",
    "telephone_Number_Enquiry_Details_International": "",
    "email_ID_Enquiry_Details_International": "",
    "website_Enquiry_Details_International": "",
    "other_Enquiry_Details_International": "",
    "name_of_Entity_Investigated_Details_International": "",
    "address_of_Entity_Investigated_Details_International": "",
    "country_Investigated_Details_International": "",
    "enquiry_Reference_Number_Investigated_Details_International": "",
    "buyer_Code_Investigated_Details_International": "",
    "telephone_Number_Investigated_Details_International": "",
    "email_ID_Investigated_Details_International": "",
    "website_Investigated_Details_International": "",
    "other_Investigated_Details_International": "",
    "history_of_Names_Name_Change_of_the_Business_Entity_International": "",
    "investigation_Notes_International": "",
    "sources_of_Information_International": "",
    "legal_Changes_in_Business_Entity_International": "",
    "bankruptcy_Filings_International": "",
    "liquidation_Filings_International": "",
    "court_Judgements_International": "",
    "tax_Liens_International": "",
    "legal_Cases_International": "",
    "others_Legal_International": "",
    "line_of_Business_International": "",
    "other_Comment_International": "",
    "payment_Experience_International": "",
    "banking_international_name": [],
    "banking_international_address": [],
    "banking_international_comment": [],
    "business_affiliates_international_name": [],
    "business_affiliates_international_affiliation_type": [],
    "business_affiliates_international_address": [],
    "business_affiliates_international_comments": [],
    "customers_international_domestic_sales_": [],
    "customers_international_export_sales_": [],
    "customers_international_domestic_customer": [],
    "customers_international_credit_term_domestic": [],
    "customers_international_export_customer": [],
    "customers_international_credit_term_export": [],
    "locations_international_address": [],
    "locations_international_type": [],
    "locations_international_size": [],
    "locations_international_rental_owned": [],
    "locations_international_lease_tenure": [],
    "locations_international_comments": [],
    "management_international_name": [],
    "management_international_designation": [],
    "management_international_nationality": [],
    "management_international_age": [],
    "management_international_qualification": [],
    "management_international_experience": [],
    "management_international_comments": [],
    "score_limit_international_score": [],
    "score_limit_international_grade": [],
    "score_limit_international_description": [],
    "score_limit_international_payment": [],
    "score_limit_international_credit_limit": [],
    "shareholding_international_shareholder_name": [],
    "shareholding_international_shareholding": [],
    "shareholding_international_nationality": [],
    "supplier_international_domestic_purchase_": [],
    "supplier_international_imports_": [],
    "supplier_international_domestic_suppliers": [],
    "supplier_international_credit_terms_domestic": [],
    "supplier_international_overseas_suppliers": [],
    "supplier_international_credit_terms_imports": [],
    "elements_Balancesheet_international": [],
    "year1_balancesheet_international":[],
    "year2_balancesheet_international":[],
    "year3_balancesheet_international_":[],
    "elements_profit_and_loss_international":[],
    "year1_profit_and_loss_international_":[],
    "year2_profit_and_loss_international":[],
    "year3_profit_and_loss_international":[]
}